export enum TrackingEvent {
  GUIDELINE_SEARCH = 'GuidelineSearch',
  GUIDELINE_SEARCH_RESULT_CLICK = 'GuidelineSearchResultClick',
  FLOWCHART_ANCHOR_LINKS_SCROLL_TO_FLOWCHART_ERROR = 'FlowchartAnchorLinksScrollToFlowchartError',
  LANGUAGE_SWITCHED = 'LanguageSwitched',
  HUB_CLICKED = 'HubClicked',
  STATISTICS_CLICKED = 'StatisticsClicked',
  NODE_DETAIL_POPOVER_TAB_VIEWED = 'NodeDetailPopoverTabViewed',
  WHATS_NEW_CLICKED = 'WhatsNewClicked',
  ATTACHMENT_DOWNLOADED = 'AttachmentDownloaded',
  FLOWCHART_FULLSCREEN_OPENED = 'FlowchartFullscreenOpened',
  FLOWCHART_PDF_EXPORTED = 'FlowchartPdfExported',
  FLOWCHART_PNG_DOWNLOADED = 'FlowchartPngDownloaded',
  GUIDELINE_PDF_EXPORTED = 'GuidelinePdfExported',
  GUIDELINE_HTML_EXPORTED = 'GuidelineHtmlExported',
  NETWORK_STATUS_CHANGED = 'NetworkStatusChanged',
}
